// removed by extract-text-webpack-plugin
module.exports = {"headerButton":"map-buttons-module__headerButton___3IxUI","nswSvg":"map-buttons-module__nswSvg___1SMS1","layersButton":"map-buttons-module__layersButton___2kXDE","nswButton":"map-buttons-module__nswButton___hAuLj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/map-buttons/map-buttons.module.scss
// module id = 120
// module chunks = 0